import { Disclosure, Transition } from "@headlessui/react";
import { BiCaretDown } from "@react-icons/all-files/bi/BiCaretDown";

const CollapseItem = ({ title, description, isOpen, toggle }) => {
  return (
    <div>
      <button
        className="w-full text-left focus:outline-none"
        onClick={toggle}
      >
        <div
          className={
            "cursor-pointer flex items-center justify-between px-7 py-4 " +
            (isOpen ? "bg-white" : "bg-brand-gray-7")
          }
        >
          <span className="text-15 text-brand-black flex-1 font-semibold">{title}</span>
          <BiCaretDown
            className={
              "text-primary transform transition-transform  " +
              (isOpen ? "rotate-180" : "")
            }
            size="25"
          />
        </div>
      </button>
      <Transition
        show={isOpen}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <div
          className="opacity-50 text-sm text-brand-black px-12 pb-8 pt-2"
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>
      </Transition>
    </div>
  );
};

export default CollapseItem;
